var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fundo container-fluid"},[_c('div',{staticClass:"row-sem-fundo"},[_c('Contact')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }